const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Workshops Manager Directive to display a list or table with tracks to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} ManageTracks the resource defined to get and set Tracks data
 */
app.directive('workshopsManager', ['Application', 'Authorization', 'Workshops', 'Viewables', 'AdminContent', '$translate', function(Application, Authorization, Workshops, Viewables, AdminContent, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        tabName: '=',
        refresh: '=?'
      },
      template: require('../../templates/directives/workshops-manager.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.directory = {};
          self.showArchiveConfirmation = false;
          self.workshops = [];
          self.per_page = 20;
          self.selection = [];
          self.workshopsRemoved = 0;
          self.loading = false;
          self.isCollaborator = function() {
            return Authorization.isCollaborator();
          };
          self.getStandardQuery = function() {
            var q = {
              subresource: '',
              types: 'workshops',
              'user-populate': 'first_name,last_name,full_name,email',
              page: 1,
              per_page: self.per_page,
              sort: 'createdAt,-1'
            };

            return q;
          };
          self.query = self.getStandardQuery();

          self.initialize = function() {
            self.initialized = true;
            self.load();
          };

          self.load = function() {
            self.loading = true;
            self.contentLoading = true;
            AdminContent.findAnalytics(self.query).$promise
            .then(function(results) {
              self.workshops.length = 0;
              self.workshopsRemoved = 0;
              self.workshops = results.data;
              self.loading = false;
              self.contentLoading = false;
            }).catch(function(error) {
              self.loading = false;
              self.contentLoading = false;
              console.log('Error getting workshops:', error);
            });
          };
          self.previous = function() {
            if (self.query.page === 1) {
              return;
            }
            self.query.page--;
            self.load();
          };
          self.next = function() {
            if (self.workshops.length !== self.per_page && !self.workshopsRemoved) {
              return;
            }
            self.query.page++;
            self.load();
          };
          self.searchItems = {
            placeholder: "Search by Title, Department, Team, Level, Grade, or Location",
            onQuery: function(opts) {
              self.query = self.getStandardQuery();
              self.query.page = 1;
              self.searching = false;
              if (opts && typeof opts === 'object' && Object.keys(opts).length) {
                self.searching = true;
              }
              if (!self.searching) {
                self.load();
                return;
              }

              for (var key in opts) {
                self.query[key] = opts[key];
              }
              self.load();
            }
          };
          self.select = function(item) {
            var id = item._id;
            var index = self.selection.indexOf(id);
            if (index === -1) {
              self.directory[id] = item;
              self.directory[id].type = self.directory[id].type ? self.directory[id].type : 'workshop';
              self.selection.push(id);
              return;
            }
            self.selection.splice(index, 1);
            delete self.directory[id];
          };
          self.removeSelections = function() {
            for (var i = self.selection.length - 1; i >= 0; i--) {
              self.select(self.directory[self.selection[i]]);
            }
            self.selection.splice(0);
          };
          self.goToAddWorkshops = function() {
            Application.navigation.goTo('edit/workshops');
          };
          self.editWorkshop = function(workshop) {
            Application.navigation.goTo('edit/workshops/' + workshop._id);
          };
          self.confirmArchive = function() {
            self.showArchiveConfirmation = true;
          };
          self.cancelArchive = function() {
            self.selection.length = 0;
            self.showArchiveConfirmation = false;
          };
          self.confirmDuplicate = function() {
            if (self.selection.length !== 1 || !self.directory[self.selection[0]] || self.duplicateLoading) {
              return;
            }
            self.toDuplicate = self.directory[self.selection[0]];
            self.showDuplicate = true;
          };
          self.duplicateWorkshop = function() {
            if (self.duplicateLoading) {
              return;
            }
            self.duplicateLoading = true;
            Workshops.duplicate({subresource: self.toDuplicate._id}, {}).$promise
                .then(function(item) {
                  self.load();
                  self.duplicateLoading = false;
                  self.showDuplicate = false;
                  self.removeSelections();
                }).catch(function(error) {
                  self.duplicateLoading = false;
                  self.showDuplicate = false;
                  console.log('error in workshop duplication', error);
                });
          };
          self.archive = function() {
            if (self.selection.length === 0 || self.workshops.length === 0) {
              return;
            }
            var selection = self.selection.map(function(workshop) {
              return {
                id: workshop,
                type: 'workshop'
              };
            });
            self.archiveInfo = {};
            self.loading = true;
            Viewables.archive({}, {content: selection}, function(data) {
              data.archived.forEach(function(archivedItem) {
                for (var index = self.workshops.length; index >= 0; index--) {
                  if (!self.workshops[index] || !self.workshops[index]._id || self.workshops[index]._id !== archivedItem) {
                    continue;
                  }
                  self.workshops.splice(index, 1);
                  self.workshopsRemoved++;
                  break;
                }
              });
              if (data.in_workflow && data.in_workflow.length) {
                self.archiveDigest = true;
                self.archiveInfo.itemToWorkflow = {}
                self.archiveInfo.in_workflow = data.in_workflow;
                if (data.containingWorkflows && data.containingWorkflows.length) {
                  data.containingWorkflows.forEach(function(item) {
                    self.archiveInfo.itemToWorkflow[item.content] = item.workflow;
                  });
                }
              }
              self.cancelArchive();
              self.loading = false;
              if (!self.archiveDigest) {
                $translate('workshopsManager.workshops_archived').then(function(translation) {
                  Application.messaging.addMessage({type: 'success', text: translation, duration: 4});
                });
              }
              $scope.refresh = 'archived';
            }, function(error) {
              console.log('Error deleting tracks:', error);
              self.cancelArchive();
              self.loading = false;
            });
          };

          $scope.$watch('refresh', function(newVal, oldVal) {
            if (!self.initialized || !newVal || newVal === oldVal) {
              return;
            }
            self.removeSelections();
            self.workshops = [];
            self.query = self.getStandardQuery();
            self.initialize();
            $scope.refresh = null;
          });

          self.initialize();

        }],
      controllerAs: 'workshopsManager'
    };
  }]);
